import {
  Gauge,
  Package,
  LogIn,
  LogOut,
  Boxes,
  ArrowLeftRight,
  Receipt,
  Settings2,
  Trash2,
  PaintBucket,
  Grid3x3,
  Printer,
  Tags,
  Users,
  Book,
  Repeat2,
  CreditCard,
  FileText,
  FileSignature,
  TrendingUp,
  Wallet,
  BarChart2,
  BarChart3,
  Calculator,
  PackageX,
  DollarSign,
  UserCog,
  Scale,
  Target,
  ListChecks,
  Shield,
  Database,
  FolderKanban,
  Bell,
  ShoppingCart,
  Banknote
} from 'lucide-react';

const routeDefinitions = [
  { id: 'dashboard', title: 'Dashboard', icon: Gauge, category: 'Genel', paths: ['/', '/dashboard'], shortcut: false },
  { id: 'stock-cards', title: 'Stok Kartları', icon: Package, category: 'Stok', paths: ['/stock-cards'] },
  { id: 'stock-entry', title: 'Stok Giriş', icon: LogIn, category: 'Stok', paths: ['/stock-entry', '/stok-giris'] },
  { id: 'stock-exit', title: 'Stok Çıkış', icon: LogOut, category: 'Stok', paths: ['/stock-exit'] },
  { id: 'stock-inventory', title: 'Stok Envanter', icon: Boxes, category: 'Stok', paths: ['/stock-inventory'] },
  { id: 'stock-movements', title: 'Stok Hareketleri', icon: ArrowLeftRight, category: 'Stok', paths: ['/stock-movements'] },
  { id: 'stock-costs', title: 'Stok Maliyetleri', icon: Receipt, category: 'Stok', paths: ['/stock-costs'] },
  { id: 'stock-adjustments', title: 'Stok Düzenlemeleri', icon: Settings2, category: 'Stok', paths: ['/stock-adjustments'] },
  { id: 'stock-reset', title: 'Stok Sıfırlama', icon: Trash2, category: 'Stok', paths: ['/stock-adjustments/reset'] },
  { id: 'stock-transfer', title: 'Depolar Arası Transfer', icon: ArrowLeftRight, category: 'Stok', paths: ['/stock-adjustments/transfer'] },
  { id: 'current-accounts', title: 'Cari Kartlar', icon: Users, category: 'Cari & Finans', paths: ['/current-accounts'] },
  { id: 'current-balances', title: 'Cari Hesaplar', icon: Book, category: 'Cari & Finans', paths: ['/finance/current-balances'] },
  { id: 'current-ledger', title: 'Cari Hesap Hareketleri', icon: Repeat2, category: 'Cari & Finans', paths: ['/finance/current-ledger'] },
  { id: 'customer-orders', title: 'Müşteri Siparişleri', icon: ShoppingCart, category: 'Müşteri Yönetimi', paths: ['/customer-management/orders'] },
  { id: 'customer-pre-orders', title: 'Müşteri Ön Siparişleri', icon: FileText, category: 'Müşteri Yönetimi', paths: ['/customer-management/pre-orders'] },
  { id: 'customer-first-sales', title: 'İlk Satışlar', icon: TrendingUp, category: 'Müşteri Yönetimi', paths: ['/customer-management/first-sales'] },
  { id: 'payments', title: 'Ödeme ve Tahsilat', icon: CreditCard, category: 'Cari & Finans', paths: ['/finance/payments'] },
  { id: 'dekont', title: 'Cari Dekont Fişleri', icon: FileText, category: 'Cari & Finans', paths: ['/finance/dekont'] },
  { id: 'check-notes', title: 'Çek / Senet Durumu', icon: FileSignature, category: 'Cari & Finans', paths: ['/finance/check-notes'] },
  { id: 'finance-movements', title: 'Finans Hareketleri', icon: TrendingUp, category: 'Cari & Finans', paths: ['/finance/movements'] },
  { id: 'expenses', title: 'Gider Yönetimi', icon: Wallet, category: 'Cari & Finans', paths: ['/finance/expenses'] },
  { id: 'boyahane', title: 'Boyahane Yönetimi', icon: PaintBucket, category: 'Üretim', paths: ['/uretim-takip/boyahane-yonetimi'] },
  { id: 'orme', title: 'Örme Yönetimi', icon: Grid3x3, category: 'Üretim', paths: ['/uretim-takip/orme-yonetimi'] },
  { id: 'baski', title: 'Baskı Yönetimi', icon: Printer, category: 'Üretim', paths: ['/uretim-takip/baski-yonetimi'] },
  { id: 'isletme-tanimlari', title: 'İşletme Tanımları', icon: Tags, category: 'Üretim', paths: ['/uretim-takip/isletme-tanimlari'] },
  { id: 'sales-reports', title: 'Satış Raporları', icon: BarChart2, category: 'Raporlar', paths: ['/reports/sales'] },
  { id: 'profit', title: 'Kar Analizi', icon: Calculator, category: 'Raporlar', paths: ['/reports/profit'] },
  { id: 'idle-stocks', title: 'Atıl Stoklar', icon: PackageX, category: 'Raporlar', paths: ['/reports/idle-stocks'] },
  { id: 'payment-collection-reports', title: 'Tahsilat ve Ödeme Raporları', icon: DollarSign, category: 'Raporlar', paths: ['/reports/payment-collection'] },
  { id: 'check-credit-activity', title: 'Çek ve kredi kartı hareketleri', icon: Banknote, category: 'Raporlar', paths: ['/reports/check-credit-activity'] },
  { id: 'stock-planning', title: 'Stok Planlama', icon: BarChart3, category: 'Raporlar', paths: ['/reports/stock-planning'] },
  { id: 'personnel', title: 'Personel Yönetimi', icon: UserCog, category: 'Yönetim', paths: ['/management/personnel'], adminOnly: true },
  { id: 'balance-sheet', title: 'Bilanço', icon: Scale, category: 'Yönetim', paths: ['/management/balance-sheet'], adminOnly: true },
  { id: 'targets', title: 'Hedefler', icon: Target, category: 'Yönetim', paths: ['/management/targets'], adminOnly: true },
  { id: 'users', title: 'Kullanıcı Yönetimi', icon: Shield, category: 'Ayarlar', paths: ['/users'], adminOnly: true },
  { id: 'definitions', title: 'Tanımlamalar', icon: ListChecks, category: 'Ayarlar', paths: ['/definitions'] },
  { id: 'database', title: 'Database Erişimi', icon: Database, category: 'Ayarlar', paths: ['/settings/database', '/database-viewer'], adminOnly: true },
  { id: 'notification-settings', title: 'Bildirim Ayarları', icon: Bell, category: 'Ayarlar', paths: ['/settings/notifications'], adminOnly: true },
  { id: 'management', title: 'Yönetimsel Raporlar', icon: FolderKanban, category: 'Yönetim', paths: ['/management'], shortcut: false }
];

const normalizePath = (pathname = '/') => {
  if (!pathname) return '/';
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.replace(/\/+$/, '');
  }
  return pathname;
};

export const getPageMeta = (pathname) => {
  const normalized = normalizePath(pathname);
  return routeDefinitions.find((route) =>
    route.paths.some((p) => {
      const base = normalizePath(p);
      if (base === '/') {
        return normalized === '/' || normalized === '';
      }
      return normalized === base || normalized.startsWith(`${base}/`);
    })
  );
};

export const shortcutOptions = routeDefinitions
  .filter((route) => route.shortcut !== false && route.paths.length > 0)
  .map((route) => ({
    id: route.id,
    title: route.title,
    icon: route.icon,
    path: route.paths[0],
    adminOnly: route.adminOnly || false,
    category: route.category || 'Diğer'
  }));

export const MAX_SHORTCUTS = 8;

